import React, { ReactElement } from 'react';
import { Routes, Route } from 'react-router';
import OktaLoginCallback from '../../../../components/okta-login-callback/okta-login-callback.component';
import Content from '../../content/content.container';
import Login from '../login/login.container';
import Registration from '../registration/registration.container';
import ForgotPassword from '../forgot-password/forgot-password.container';
import PasswordRecovery from '../password-recovery/password-recovery.container';
import Verification from '../verification/verification.container';
import VerificationSetup from '../verification-setup/verification-setup.container';
import {
  ROUTE_CONTENT_ALL, ROUTE_FORGOT_PASSWORD, ROUTE_LOGIN, ROUTE_OKTA_LOGIN_CALLBACK, ROUTE_PARAM_HASH,
  ROUTE_PASSWORD_RECOVERY, ROUTE_REGISTRATION, ROUTE_VERIFICATION, ROUTE_VERIFICATION_SETUP,
} from '../../../../constants/system/routes';

const InitialContentRoutes: ReactComponent = (): ReactElement => (
  <Routes>
    <Route path={ROUTE_LOGIN} element={<Login />} />
    <Route path={`${ROUTE_REGISTRATION}/:${ROUTE_PARAM_HASH}`} element={<Registration />} />
    <Route path={ROUTE_FORGOT_PASSWORD} element={<ForgotPassword />} />
    <Route path={`${ROUTE_PASSWORD_RECOVERY}/:${ROUTE_PARAM_HASH}`} element={<PasswordRecovery />} />
    <Route path={`${ROUTE_VERIFICATION_SETUP}/:${ROUTE_PARAM_HASH}`} element={<VerificationSetup />} />
    <Route path={`${ROUTE_VERIFICATION}/:${ROUTE_PARAM_HASH}`} element={<Verification />} />
    <Route path={ROUTE_OKTA_LOGIN_CALLBACK} element={<OktaLoginCallback />} />
    <Route path={ROUTE_CONTENT_ALL} element={<Content />} />
  </Routes>
);

export default InitialContentRoutes;
